module.exports = __webpack_public_path__ + "images/a623b1d2511b4227f30de6f47ae1049b.png";